import * as http from './http'

import { SchoolSearchResultModel } from '@ViewModels/SchoolSearchResultModel'

const schoolApi = '/api/SchoolApi'

export const search = async (query: string): Promise<SchoolSearchResultModel[]> => {
   const url = `${schoolApi}/Search?query=${query}`
   return http.get(url)
}
